import * as helpers from "./helpers";
import { GeoJSON } from "ol/format.js";
import ImageWMS from "ol/source/ImageWMS.js";
import ImageLayer from "ol/layer/Image.js";
import TileLayer from "ol/layer/Tile.js";
import { Feature } from 'ol';
import Polygon from "ol/geom/Polygon";
import LineString from "ol/geom/LineString";
import Point from "ol/geom/Point";
import WKT from 'ol/format/WKT';

export function arrayToDictionary(array) {
  var dict = [];
  array.forEach((item) => {
    dict.push({
      // key: "value",
      value: item,
    });
  });
  return dict;
}

export function arrayToDictionary2(array) {
  var dict = [];
  array.forEach((item) => {
    dict.push({
      key: helpers.getUID(),
      value: item,
      attributes: "",
    });
  });
  return dict;
}

export function arrayToDictionary3(array) {
  var dict = [];
  array.forEach((item) => {
    dict.push({
      key: helpers.getUID(),
      value: item,
      attributes: "",
      text: item,
    });
  });
  return dict;
}

export function arrayToDictionary4(array) {
  var dict = [];
  array.forEach((item) => {
    dict.push({
      key: helpers.getUID(),
      value: item.field,
      attributes: "",
      text: item.alias,
    });
  });
  return dict;
}

// GET STORAGE
export function getStorage(storageKey) {
  const storage = localStorage.getItem(storageKey);
  if (storage === null) return [];

  const data = JSON.parse(storage);
  return data;
}

export function appendToStorage(storageKey, item, limit = undefined) {
  let items = helpers.getItemsFromStorage(storageKey);
  if (items === undefined) items = [];
  item.dateAdded = new Date().toLocaleString();
  items.unshift(item);
  if (limit !== undefined) {
    if (items.length > limit) items.pop();
  }
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(items));
  } catch (e) {
    helpers.cleanupStorage();
  }
}

export function getUniqueName(customFilterName, defaultFilterName, usedFilterNames) {

  const uniqueFilterNameBase = customFilterName || defaultFilterName;

  // If the name isn't used, return it immediately
  if (!usedFilterNames.includes(uniqueFilterNameBase)) {
    return uniqueFilterNameBase;
  }

  // Extract base name and numeric suffix if they exist
  let matches = uniqueFilterNameBase.match(/(.*?)(?:_(\d+))?$/);
  const base = matches[1];
  let counter = parseInt(matches[2]) || 1;

  let potentialName = base + "_" + counter;

  // Find an unused name
  while (usedFilterNames.includes(potentialName)) {
    counter += 1;
    potentialName = base + "_" + counter;
  }

  return potentialName;
}

export const isFilterFilled = (
  geoserverUrl,
  selectedLayer,
  userQuery,
  layer
) => {
  let layerType = layer.get("rebuildParams").sourceType;
  if (layerType === "ImageArcGISRest") {
    return new Promise((resolve) => {
      helpers.getArcgisGeoJSON(
        layer,
        userQuery,
        null,
        null,
        null,
        (result) => {
          resolve({ is: result.length > 0 ? true : false, geojson: result });
        },
        null,
        null,
        userQuery,
        1
      );
    });
  } else {
    return new Promise((resolve) => {
      helpers.getWFSGeoJSON(
        geoserverUrl,
        selectedLayer,
        (result) => {
          resolve({ is: result.length > 0 ? true : false });
        },
        null,
        null,
        userQuery,
        1
      );
    });
  }
};

export const getOrigGeomName = (geoserverUrl, selectedLayer) => {
  return new Promise((resolve) => {
    helpers.getWFSGeoJSON(
      geoserverUrl,
      selectedLayer,
      (result) => {
        resolve(result[0].values_.orig_geom_name);
      },
      null,
      null,
      null,
      2,
      null
    );
  });
};

export const isFilterCorrect = (geoserverUrl, selectedLayer, userQuery) => {
  return new Promise((resolve, reject) => {
    helpers.getWFSGeoJSON(
      geoserverUrl,
      selectedLayer,
      (result) => {
        resolve(true);
      },
      null,
      null,
      userQuery,
      1
    );
  });
};

export const getLayerList = (allLayers, geoserverUrl) => {
  let layerList = [];
  let newLayer = "";
  return new Promise((resolve) => {
    allLayers.map((wfsLayer) => {
      helpers.getWFSGeoJSON(
        geoserverUrl,
        wfsLayer,
        (result) => {
          if (result) {
            newLayer = {
              key: helpers.getUID(),
              value: wfsLayer,
              attributes: "",
              text: wfsLayer,
            };
            layerList.push(newLayer);
          }
        },
        null,
        null,
        null,
        5
      );
    });
    resolve(layerList);
  });
};

export const getLayersFromStorage = (showAllLayers) => {
  const excludedLayers = window.config.filterExcludedLayers;
  const layersMetadata = window.config.allLayers;

  let layers = [];

  if (true) {
    window.emitter.emit("getLayerList", (groups) => {
      Object.entries(groups).forEach((row) => {
        const layerItems = row[1];
        layerItems.forEach((layer) => {
          if (layer.tocDisplayName !== undefined) {
            if (excludedLayers.includes(layer.displayName)) return;
            if (layer.layer.values_.queryable === false) return;

            const metadata = layersMetadata.find(meta => meta.name === layer.name);
            if (metadata) {
              if (metadata.priority === 0 && !showAllLayers) return;
            }

            layers.push({
              fullName: layer.name,
              name: layer.tocDisplayName,
              type: "Map Layer",
              layerGroupName: layer.groupName,
              layerGroup: layer.group,
              key: helpers.getUID(),
              value: layer.name,
              text: layer.displayName,
              attributes: "",
              index: layer.index,
              jsonUrl: layer.jsonUrl,
              userLayer: layer.userLayer,
              queryable: layer.queryable,
              order: metadata ? metadata.order : Infinity,
            });
          }
        });
      });
    });
    // Zoradenie vrstiev
    layers.sort((a, b) => {
      return (a.order === Infinity && b.order === Infinity) ? 0 : (a.order || Infinity) - (b.order || Infinity);
    });

    helpers.saveToStorage("savedLayers", layers);
  }

  return layers;
};

// export const getUsedFilterNames = () => {
//   const savedFilter = helpers.getItemsFromStorage("Filter results");
//   savedLayers.map((a)=> console.log(a.name));
//   // let layers = [];
//   // if (savedLayers === undefined) {
//   //   window.emitter.emit("getLayerList", (groups) => {
//   //     Object.entries(groups).forEach((row) => {
//   //       const layerItems = row[1];
//   //       layerItems.forEach((layer) => {
//   //         if (layer.tocDisplayName !== undefined) {
//   //           layers.push({
//   //             fullName: layer.name,
//   //             name: layer.tocDisplayName,
//   //             type: "Map Layer",
//   //             layerGroupName: layer.groupName,
//   //             layerGroup: layer.group,
//   //             key: helpers.getUID(),
//   //             value: layer.name,
//   //             text: layer.name,
//   //             attributes: "",
//   //             index: layer.index,
//   //           });
//   //         }
//   //       });
//   //     });
//   //   });
//   //   helpers.saveToStorage("savedLayers", layers);
//   // } else {
//   //   layers = savedLayers;
//   // }
//   // return layers;
// };

export const getStorageItems = (key) => {
  let results = helpers.getItemsFromStorage(key);
  if (results) {
    return results;
  } else {
    return [];
  }
};

export const getPreviousResults = (key) => {
  const tempResults = window.filterResults;
  const storageResults = getStorageItems(key);

  let prevRes = "";
  if (tempResults !== undefined && tempResults.length > 0) {
    prevRes =
      storageResults === undefined
        ? tempResults
        : tempResults.concat(storageResults);
  } else {
    prevRes = storageResults;
  }

  prevRes.map((res) => {
    res["text"] = res["alias"] ? res["alias"] : res["name"];
    res["value"] = res["alias"] ? res["alias"] : res["name"];
    res["key"] = helpers.getUID();
    return res;
  });

  const reducedPrevRes = prevRes.map(({ text, value, key }) => {
    return {
      text,
      value,
      key,
    };
  });
  return {
    previousResults: prevRes,
    previousResultsForDropdown: reducedPrevRes,
  };
};


export const extractUsedFilterNames = (key) => {
  let usedNames = [];
  const arrayOfNames = getPreviousResults(key).previousResults;
  arrayOfNames.map((res) => {
    usedNames.push(res.value);
  });
  return usedNames;
};

export const renderFeature = (item, source, visibility) => {
  postLongGeometry(
    item.layerName,
    item.cqlFilter,
    item.id,
    item.sortFields,
    10000000,
    (result) => {
      if (result.length !== 0) {
        if (item.length === 0) return;
        const id = item.alias ? item.alias : item.id;
        const tabName = item.alias ? item.alias : item.name;
        window.emitter.emit(
          "renderFeature",
          result,
          item.layerName,
          tabName,
          id,
          source,
          visibility
        );
        // window.emitter.emit("highlightOnMap", result);
      }
    }
  );
};

// export const getJSON_lg = (requestOptions, callback) => {
//   return fetch(window.config.geoserverUrl + "wfs?", requestOptions)
//     .then((response) => response.json())
//     .then((responseJson) => {
//       //     // CALLBACK WITH RESULT
//       if (callback !== undefined) callback(responseJson);
//     })
//     .catch((error) => {
//       console.error("Error: ", error, "URL:", requestOptions);
//     });
// };

export const getJSON_lg = (requestOptions, callback) => {
  return fetch(window.config.geoserverUrl + "wfs?", requestOptions)
      .then((response) => {
          // Skontroluj status odpovede
          if (!response.ok) {
              // Ak nie je odpoveď úspešná, vráť textovú odpoveď pre lepšie logovanie chyby
              return response.text().then((errorText) => {
                  throw new Error(`HTTP Error: ${response.status} - ${response.statusText}. Response: ${errorText}`);
              });
          }

          // Over, či je odpoveď typu JSON
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.includes("application/json")) {
              return response.json();
          } else {
              // Ak odpoveď nie je JSON, vráť textovú odpoveď
              return response.text().then((text) => {
                  throw new Error(`Unexpected response format: ${text}`);
              });
          }
      })
      .then((responseJson) => {
          // CALLBACK S VÝSLEDKOM
          if (callback !== undefined) callback(responseJson);
      })
      .catch((error) => {
          console.error("Error:", error.message, "URL:", requestOptions);
          if (callback !== undefined) callback([]); // Zavolajte callback s prázdnym poľom v prípade chyby
      });
};


export const getJSON_lgExt = (url, requestOptions, callback) => {
  console.log("getJSON_lgExt");
  return fetch(url, requestOptions)
    .then((response) => response.json())
    .then((responseJson) => {
      //     // CALLBACK WITH RESULT
      if (callback !== undefined) callback(responseJson);
    })
    .catch((error) => {
      console.error("Error: ", error, "URL:");
    });
};

export const postLongGeometry = (
  selectedLayer,
  cqlFilter,
  featureID,
  sortFields,
  maxRecords,
  callback
) => {
  console.log("in postLongGeometry");
  // SORTING
  var myHeaders = new Headers();
  myHeaders.append("Accept", "application/json");
  myHeaders.append(
    "Content-Type",
    "application/x-www-form-urlencoded; charset=UTF-8"
  );
  myHeaders.append(
    "Cookie",
    "GS_FLOW_CONTROL=GS_CFLOW_1fcee178:183e4d66455:-51c2"
  );

  var urlencoded = new URLSearchParams();
  urlencoded.append("service", "WFS");
  urlencoded.append("request", "GetFeature");
  urlencoded.append("outputFormat", "application/json");

  if (maxRecords !== undefined && maxRecords !== null) urlencoded.append("count", maxRecords);
  if (sortFields !== undefined && sortFields !== null) urlencoded.append("sortBy", sortFields);

  if (featureID === undefined) {
    if (cqlFilter !== undefined) {
      urlencoded.append("CQL_FILTER", decodeURIComponent(cqlFilter));
    }
  } else {
    urlencoded.append("featureID", featureID);
  }
  urlencoded.append("typeNames", selectedLayer);
  urlencoded.append("version", "2.0.0");


  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  };

  getJSON_lg(requestOptions, (result) => {
    if (result.features.length > 0) {
      
      const featureLength = result.features?.[0]?.geometry?.coordinates?.[0]?.[0]?.[0]?.length ?? undefined;
      if (featureLength & (featureLength === 3)) {
        result.features.forEach((feature) => {
          const coords = feature.geometry.coordinates;

          for (let i = 0; i < coords.length; i++) {
            const geom = coords[i];
            for (let j = 0; j < geom.length; j++) {
              const coord = geom[j];
              for (let k = 0; k < coord.length; k++) {
                const c = coord[k];
                coords[i][j][k] = c.slice(0, 2);
              }
            }
          }
        });
      }
    }
    const geoJSON = new GeoJSON().readFeatures(result);
    callback(geoJSON);
  });
};

export const postLongGeometryExt = (
  url,
  selectedLayer,
  cqlFilter,
  featureID,
  sortFields,
  maxRecords,
  callback
) => {
  console.log("in postLongGeometryExt");
  const baseUrl = url.match(/^https?:\/\/[^/]+/)[0];
  // SORTING
  var myHeaders = new Headers();
  myHeaders.append("Accept", "GEOJSON");
  //   myHeaders.append("Accept", "application/json");
  myHeaders.append(
    "Content-Type",
    "application/x-www-form-urlencoded; charset=UTF-8"
  );
  myHeaders.append(
    "Cookie",
    "GS_FLOW_CONTROL=GS_CFLOW_1fcee178:183e4d66455:-51c2"
  );

  var urlencoded = new URLSearchParams();
  urlencoded.append("service", "WFS");
  urlencoded.append("request", "GetFeature");
  urlencoded.append("outputFormat", "GEOJSON");
  //   urlencoded.append("outputFormat", "application/json");
  //   if (maxRecords !== undefined) urlencoded.append("count", maxRecords);
  //   if (sortFields !== undefined || sortFields !== "") urlencoded.append("sortBy", sortFields);

  if (featureID === undefined) {
    if (cqlFilter !== undefined) {
      urlencoded.append("FILTER", cqlFilter);
    }
  } else {
    urlencoded.append("featureID", featureID);
  }
  urlencoded.append("typeNames", selectedLayer);
  urlencoded.append("version", "2.0.0");

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  };

  getJSON_lgExt(baseUrl, requestOptions, (result) => {
    if (result.features.length > 0) {
      const featureLength =
        result.features[0].geometry.coordinates[0][0][0]?.length || undefined;
      if (featureLength & (featureLength === 3)) {
        result.features.forEach((feature) => {
          const coords = feature.geometry.coordinates;

          for (let i = 0; i < coords.length; i++) {
            const geom = coords[i];
            for (let j = 0; j < geom.length; j++) {
              const coord = geom[j];
              for (let k = 0; k < coord.length; k++) {
                const c = coord[k];
                coords[i][j][k] = c.slice(0, 2);
              }
            }
          }
        });
      }
    }
    const geoJSON = new GeoJSON().readFeatures(result);
    callback(geoJSON);
  });
};

//   export const getData = (item, callback) => {
//     this.setState({ isLoading: true }, () => {
//       helpers.getWFSGeoJSON(
//         item.serverUrl,
//         item.layerName,
//         (result) => {
//           if (result.length === 0) return;

//           // ATTACH GEOJSON
//           item.geoJson = result;
//           // GET TOTAL NUM RECORDS
//           helpers.getWFSLayerRecordCount(
//             item.serverUrl,
//             item.layerName,
//             item.cqlFilter,
//             (count) => {
//               item.total = count;
//               let itemFound = this.getItemByname(item.name);
//               const isVisible = this.state.visible;
//               if (itemFound === undefined) {
//                 this.setState(
//                   (prevState) => ({
//                     visible: true,
//                     items: [item, ...prevState.items],
//                     isLoading: false,
//                   }),
//                   () => {
//                     if (!isVisible) {
//                       this.updateSize();
//                     }
//                   }
//                 );
//               } else {
//                 this.setState(
//                   {
//                     // UPDATE ITEMS
//                     items: this.state.items.map((stateItem) =>
//                       stateItem.name === item.name
//                         ? Object.assign({}, stateItem, { geoJson: result })
//                         : stateItem
//                     ),
//                     isLoading: false,
//                   },
//                   () => {
//                     if (!isVisible) {
//                       this.updateSize();
//                     }
//                   }
//                 );
//               }
//             }
//           );
//         },
//         item.sortFields,
//         null,
//         item.cqlFilter,
//         item.maxRecords
//       );
//     });
//   };

export function getLongGeoJSONFromURL(url, callback) {
  const trimUrl = url.replace(/&cql_filter=/, "");
  return fetch(trimUrl)
    .then((response) => response.text())
    .then((result) => new GeoJSON().readFeatures(result))
    .catch((error) => console.log("error", error));
}

export function convertFeaturesToWKT(features) {
  console.log("convertFeaturesToWKT");
  if (!Array.isArray(features)) {
    features = [features];
  }
  let geomType = features[0].getGeometry().getType();

  if (features.length > 1) {
    if (!geomType.toLowerCase().startsWith("multi")) {
      geomType = "Multi" + geomType;
    }
  }

  const wktFormatter = new WKT();

  const transformFeatureToWKT = (feature) => {
    let geometryWkt = wktFormatter.writeGeometry(feature.getGeometry());
    if (/Z\(/g.test(geometryWkt)) {
      geometryWkt = geometryWkt.replace(/Z\(/g, '(');
      geometryWkt = geometryWkt.replace(/ ([-]?\d+(\.\d+)?)(,|\))/g, '$3');
    }

    const allGeomTypes = ["polygon", "multipolygon", "linestring", "multilinestring", "point", "multipoint"];
    allGeomTypes.forEach(geomType => {
      const internalGeomTypePattern = new RegExp("^" + geomType + "\\s*", 'i');
      if (internalGeomTypePattern.test(geometryWkt)) {
        geometryWkt = geometryWkt.replace(internalGeomTypePattern, '');
      }
    });

    // Replace multiple brackets
    geometryWkt = geometryWkt.replace(/\({2,}/g, '((');
    geometryWkt = geometryWkt.replace(/\){2,}/g, '))');

    return geometryWkt;
  };

  const geometries = features.map(transformFeatureToWKT);
  let resultWkt;
  if (geomType.toLowerCase() === "multipolygon") {
    resultWkt = `${geomType}(${geometries.join(",")})`;
  } else {
    resultWkt = `${geomType}${geometries[0]}`;
  }

  return resultWkt;
}


// export function convertFeaturesToWKT(features) {

//   if (!Array.isArray(features)) {
//     features = [features];
//   }

//   let geomType = features[0].getGeometry().getType();
//   console.log("geomType", geomType);

//   // Kontrola podmínky a změna na MultiPolygon, pokud je to potřeba
//   let newGeomType = geomType;
//   if (features.length > 1 && geomType.toLowerCase() === "polygon") {
//      newGeomType = "MultiPolygon";
//   }

//   const wktFormatter = new WKT();

//   const transformFeatureToWKT = (feature) => {
//     let geometryWkt = wktFormatter.writeGeometry(feature.getGeometry());
//     console.log("geometryWkt0", geometryWkt);

//     if (/Z\(/g.test(geometryWkt)) {
//       geometryWkt = geometryWkt.replace(/Z\(/g, '(');
//       geometryWkt = geometryWkt.replace(/ ([-]?\d+(\.\d+)?)(,|\))/g, '$3');
//     }
//     const internalGeomTypePattern = new RegExp("^" + geomType + "\\s*", 'i');
//     // const internalGeomTypePattern = new RegExp("^" + geomType + "\\s*\\(", 'i');
//     if (internalGeomTypePattern.test(geometryWkt)) {
//       geometryWkt = geometryWkt.replace(internalGeomTypePattern, '');
//     }

//     // if (geometryWkt.startsWith("((") && geometryWkt.endsWith("))")) {
//     geometryWkt = geometryWkt.slice(1, -1);
//     // }


//     console.log("geometryWkt", geometryWkt);
//     return geometryWkt;  // Tu nepridávame ďalšie zátvorky
//   };

//   let resultWkt;
//   const geometries = features.map(transformFeatureToWKT);

//   console.log("newGeomType", newGeomType);

//   if (features.length === 1) {
//     resultWkt = `${newGeomType}(${geometries.join(",")})`;
//   } else {
//     if (newGeomType === "MultiPolygon") {
//       console.log("tu");
//       resultWkt = `${newGeomType}((${geometries.join("),(")}))`;
//     } else {
//       resultWkt = `${newGeomType}(${geometries.join(",")})`;
//     }
//   }


//   console.log("resultWkt", resultWkt);
//   return resultWkt;
// }



export function formatCoords(poly, geomType, mergedCoords) {
  console.log("in formatCoords");

  let sur = helpers.getWKTStringFromFeature(poly);
  sur = sur.replace(/POLYGON/g, "");
  sur = sur.replace(/LINESTRING/g, "");
  sur = sur.replace(/MULTILINESTRING/g, "");
  sur = sur.replace(/POINT/g, "");
  sur = sur.replace(/MULTI/g, "");
  sur = sur.replace(/^./, "");
  sur = sur.replace(/.$/, "");

  const geomLowerCase = geomType.toLowerCase();
  if (geomLowerCase === "multipoint") {
    mergedCoords === undefined
      ? (mergedCoords = "" + sur + "")
      : (mergedCoords = mergedCoords + "," + sur + "");
  } else {
    mergedCoords === undefined
      ? (mergedCoords = sur)
      : (mergedCoords = mergedCoords + "," + sur);
  }
  return mergedCoords;
}

export function formatFeatureCoords(feature, geomType) {
  const mergedCoords = convertFeaturesToWKT(feature);
  // if (Array.isArray(feature)) {
  //   mergedCoords = feature.reduce(
  //     (acc, poly) => convertFeaturesToWKT(poly, geomType, acc),
  //     mergedCoords
  //   );
  // } else {
  //   mergedCoords = convertFeaturesToWKT(feature, geomType, mergedCoords);
  // }
  // if (
  //   geomType.toLowerCase() === "multipolygon" &&
  //   !mergedCoords.startsWith("((")
  // ) {
  //   mergedCoords = "(" + mergedCoords + ")";
  // }
  // if (geomTypeFromFeature && geomTypeFromFeature.toLowerCase() === "polygon") {
  //   mergedCoords = "(" + mergedCoords + ")";
  // }
  return mergedCoords;
}

export function preprocessFilters(filters) {
  let preprocessFilters = filters.map((filter) => {
    return {
      operator: getOperator(filter),
      xmlFilter: convertCqlToXml(filter),
    };
  });
  return preprocessFilters;
}

export function getOperator(str) {
  let firstWord = str.trim().split(" ")[0];
  if (firstWord === "OR" || firstWord === "AND") {
    firstWord = firstWord.toLowerCase();
    return firstWord.charAt(0).toUpperCase() + firstWord.slice(1);
  } else {
    return "";
  }
}

export function convertCqlToXml(cqlFilter) {
  let property, value, operator, operator2, value2, element;

  if (cqlFilter.startsWith("AND ")) {
    cqlFilter = cqlFilter.slice(4);
  } else if (cqlFilter.startsWith("OR ")) {
    cqlFilter = cqlFilter.slice(3);
  }

  if (cqlFilter.includes("BETWEEN")) {
    [property, operator, value, operator2, value2] = cqlFilter
      .trim()
      .split(" ");

    property = property.trim();
    value = value.trim();
    value2 = value2.trim();
    operator = operator.trim();
    operator2 = operator2.trim();

    const operatorTag = "Between";
    const literalValue = `<Literal>${value}</Literal>`;
    const literalValue2 = `<Literal>${value2}</Literal>`;

    element = `<PropertyIs${operatorTag}><PropertyName>${property}</PropertyName><LowerBoundary>${literalValue}</LowerBoundary><UpperBoundary>${literalValue2}</UpperBoundary></PropertyIs${operatorTag}>`;
  } else if (cqlFilter.includes("IN")) {
    [property, operator, value] = cqlFilter.split(/(!=|<>|=|LIKE|[<>]=?|IN)/);

    const values = value.split(/[,\(\)]/).filter(Boolean);
    const filteredValues = values.filter((val) => val.trim() !== "");

    property = property.trim();
    operator = operator.trim();
    let operatorTag = "EqualTo";

    let orFilter = "";
    filteredValues.forEach((val) => {
      orFilter += `<PropertyIs${operatorTag}><PropertyName>${property}</PropertyName><Literal>${val.trim()}</Literal></PropertyIs${operatorTag}>`;
    });

    element = `<Or>${orFilter}</Or>`;
  } else if (cqlFilter.includes("IS NULL")) {
    [property, operator] = cqlFilter.split(/(IS NULL)/);
    property = property.trim();

    const operatorTag = "Null";
    element = `<PropertyIs${operatorTag}><PropertyName>${property}</PropertyName></PropertyIs${operatorTag}>`;
  } else if (cqlFilter.includes("IS NOT NULL")) {
    [property, operator] = cqlFilter.split(/(IS NOT NULL)/);
    property = property.trim();

    const operatorTag = "NotNull";
    element = `<PropertyIs${operatorTag}><PropertyName>${property}</PropertyName></PropertyIs${operatorTag}>`;
  } else {
    [property, operator, value] = cqlFilter.split(/(!=|<>|=|LIKE|[<>]=?)/);
    property = property.trim();
    value = value.trim();
    operator = operator.trim();

    let operatorTag;
    let literalValue;

    switch (operator) {
      case "=":
        operatorTag = "EqualTo";
        literalValue = `<Literal>${value}</Literal>`;
        break;
      case "!=":
      case "<>":
        operatorTag = "NotEqualTo";
        literalValue = `<Literal>${value}</Literal>`;
        break;
      case "LIKE":
        operatorTag = "Like";
        literalValue = `<Literal>${value.replace(/\*/g, "%")}</Literal>`;
        break;
      case ">":
        operatorTag = "GreaterThan";
        literalValue = `<Literal>${value}</Literal>`;
        break;
      case ">=":
        operatorTag = "GreaterThanOrEqualTo";
        literalValue = `<Literal>${value}</Literal>`;
        break;
      case "<":
        operatorTag = "LessThan";
        literalValue = `<Literal>${value}</Literal>`;
        break;
      case "<=":
        operatorTag = "LessThanOrEqualTo";
        literalValue = `<Literal>${value}</Literal>`;
        break;
      default:
        throw new Error(`Invalid operator: ${operator}`);
    }
    element = `<PropertyIs${operatorTag}><PropertyName>${property}</PropertyName>${literalValue}</PropertyIs${operatorTag}>`;
  }
  return element;
}

export function convertFiltersToXml(filters) {

  let xml = "";

  if (filters.length === 1) {
    const filter = filters[0].xmlFilter;
    xml += filter;
  } else {
    filters.forEach((filter, index) => {
      const operator = filters[index].operator;
      const filter1 = filters[index].xmlFilter;

      if (operator === "") {
        xml += filter1;
      } else if (operator === "And" || operator === "Or") {
        xml += filter1;
        xml = `<${operator}>${xml}</${operator}>`;
      }
    });
  }
  xml = `<Filter>${xml}</Filter>`;
  return xml;
}

export function getTopVisibleWmsLayer() {
  console.log("in getTopVisibleWmsLayer");
  let layers = window.map.getLayers().getArray();

  let topWmsLayer = null;

  for (let i = 0; i < layers.length; i++) {
    if (typeof layers[i].getSource === "function") {
      let source = layers[i].getSource();
      if (
        (layers[i] instanceof TileLayer || layers[i] instanceof ImageLayer) &&
        source instanceof ImageWMS &&
        layers[i].getVisible()
      ) {
        if (
          topWmsLayer === null ||
          layers[i].getZIndex() > topWmsLayer.getZIndex()
        ) {
          topWmsLayer = layers[i];
        }
      }
    }
  }
  return topWmsLayer;
}

export function MapWithGetFeatureInfo() {
  // Funkcia na získanie GetFeatureInfo
  const getFeatureInfo = async (e) => {
    const { lat, lng } = e.latlng;
    const wmsUrl = "http://example.com/wms"; // Nahraďte URL adresou vášho WMS servera
    const layerName = "my_wms_layer"; // Nahraďte názvom vášho WMS ImageLayer

    try {
      const response = await fetch(
        `${wmsUrl}?request=GetFeatureInfo&service=WMS&version=1.1.1&layers=${layerName}&query_layers=${layerName}&info_format=application/json&width=1&height=1&srs=EPSG:4326&bbox=${lng},${lat},${lng},${lat}&x=1&y=1`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
    } catch (error) {
      console.error("Chyba pri získavaní informácií o prvkoch:", error);
    }
  };
}

export function parseXML(xmlText) {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlText, "text/xml");

  const fieldsElement = xmlDoc.getElementsByTagName("FIELDS")[0];
  const attributes = fieldsElement.attributes;
  const attributeData = {};

  for (let i = 0; i < attributes.length; i++) {
    const attr = attributes[i];
    attributeData[attr.name] = attr.value;
  }

  return attributeData;
}

export function getAllVisibleLayers() {
  let layers = window.map.getLayers().getArray();

  let visibleLayers = [];

  for (let i = 0; i < layers.length; i++) {
    if (typeof layers[i].getSource === "function") {
      let source = layers[i].getSource();
      if (
        (layers[i] instanceof TileLayer || layers[i] instanceof ImageLayer) &&
        source instanceof ImageWMS &&
        layers[i].getVisible()
      ) {
        visibleLayers.push(layers[i]);
      }
    }
  }
  return visibleLayers;
}

export function getSupportedInfoFormats(layer) {
  const source = layer.getSource();
  const url = source.getUrl(); // používa metódu getUrl() namiesto getUrls()

  // vygenerovanie URL pre GetCapabilities požiadavku
  const capabilitiesUrl =
    url + "?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities";

  return fetch(capabilitiesUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then((data) => {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(data, "text/xml");

      const getFeatureInfoFormats = [];
      const getFeatureInfoElement =
        xmlDoc.getElementsByTagName("GetFeatureInfo")[0];
      if (getFeatureInfoElement) {
        const formatElements =
          getFeatureInfoElement.getElementsByTagName("Format");
        for (let i = 0; i < formatElements.length; i++) {
          getFeatureInfoFormats.push(formatElements[i].textContent);
        }
      }

      return getFeatureInfoFormats;
    })
    .catch((e) =>
      console.error(
        "There was a problem with the fetch operation: " + e.message
      )
    );
}

//   export async function getWMSServiceLayerInfo (layer) {
//     const source = layer.getSource();
//     const url = source.getUrl();

//     const capabilitiesUrl =
//       url + "?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities";
//     console.log("capabilitiesUrl", capabilitiesUrl);

//     try {
//       const response = await fetch(capabilitiesUrl);

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.text();
//       const parser = new DOMParser();
//       const xmlDoc = parser.parseFromString(data, "text/xml");

//       const layerElements = xmlDoc.getElementsByTagName("Layer");
//       console.log("layerElements", layerElements);

//       let boundingBox = null;
//       const boundingBoxElements = xmlDoc.getElementsByTagName("BoundingBox");

//       for (let i = 0; i < boundingBoxElements.length; i++) {
//         const element = boundingBoxElements[i];
//         if (element.getAttribute("CRS") === "EPSG:5514") {
//           boundingBox = {
//             minx: parseFloat(element.getAttribute("minx")),
//             miny: parseFloat(element.getAttribute("miny")),
//             maxx: parseFloat(element.getAttribute("maxx")),
//             maxy: parseFloat(element.getAttribute("maxy")),
//           };
//           break;
//         }
//       }

//       for (let i = 0; i < layerElements.length; i++) {
//         const element = layerElements[i];

//         const name = element.getElementsByTagName("Name")[0]?.textContent;
//         const title = element.getElementsByTagName("Title")[0]?.textContent;
//         const abstract =
//           element.getElementsByTagName("Abstract")[0]?.textContent;

//         // Get CRS information
//         const crs = [];
//         const crsElements = element.getElementsByTagName("CRS");
//         for (let j = 0; j < crsElements.length; j++) {
//           const crsValue = crsElements[j]?.textContent;
//           if (crsValue === "EPSG:5514") {
//             // If we find EPSG:5514, we return immediately, prioritizing this CRS
//             return {
//               name: name,
//               title: title,
//               abstract: abstract,
//               crs: crsValue,
//               boundingBox: boundingBox,
//             };
//           }
//           crs.push(crsValue);
//         }

//         console.log("rovna sa?", title === layer.get("displayName"));

//         if (title === layer.get("displayName")) {
//           console.log("DNU SOM");
//           return {
//             name: name,
//             title: title,
//             abstract: abstract,
//             crs: crs.join(", "), // join all CRS values with a comma
//             boundingBox: boundingBox,
//           };
//         }
//       }

//       throw new Error(`No Layer found for layer name: ${layer.get("name")}`);
//     } catch (e) {
//       console.error(
//         "There was a problem with the fetch operation: " + e.message
//       );
//     }
//   };

// Táto funkcia získa štruktúru údajov (typy a atribúty) pre danú vrstvu služby WFS.
export async function getAttributes(layer) {

  // Získame zdroj vrstvy a URL pre dotazovanie služby.
  const source = layer.getSource();
  // V URL nahradíme "wms" za "wfs", aby sme mohli spraviť požiadavku na službu WFS.
  const url = source.getUrl().replace(/wms/i, "wfs");
  // Zostavíme URL pre požiadavku DescribeFeatureType.
  const describeFeatureTypeUrl = `${url}?service=WFS&version=1.1.0&request=DescribeFeatureType`;

  try {
    // Posielame požiadavku na získanie opisu štruktúry údajov vrstvy.
    const response = await fetch(describeFeatureTypeUrl);

    // Kontrolujeme, či je odpoveď v poriadku.
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Získame dáta odpovede a prevádzame ich na text.
    const data = await response.text();

    // Pomocou DOMParser premeníme text na XML dokument.
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(data, "text/xml");

    // Získame zoznam všetkých atribútov vrstvy a ich typov.
    const attributeList = [];
    const elements = xmlDoc.getElementsByTagName("xsd:element");

    // Prechádzame všetkými elementmi a získavame ich názvy a typy.
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      const name = element.getAttribute("name");
      let type = element.getAttribute("type");

      // Pre komplexné typy sa môže typ nachádzať v elemente "xsd:simpleType".
      if (!type) {
        // for complex types
        const simpleType = element.getElementsByTagName("xsd:simpleType")[0];
        if (simpleType) {
          const restriction =
            simpleType.getElementsByTagName("xsd:restriction")[0];
          if (restriction) {
            type = restriction.getAttribute("base");
          }
        }
      }
      // Odstránime 'xsd:' z typu.
      if (type) {
        type = type.replace("xsd:", "");
      }
      // Pridáme atribút do zoznamu.
      attributeList.push({
        name: name,
        type: type,
      });
    }

    // Vrátime zoznam všetkých atribútov a ich typov.
    return attributeList;
  } catch (e) {
    // Ak nastala chyba počas operácie, vypíšeme ju do konzoly.
    console.error("There was a problem with the fetch operation: " + e.message);
  }
}

// Funkcia na získanie metadát o vrstve
export async function getWFSAttributes(layer) {
  console.log("in getWFSAttributes");
  // Získanie URL zdroja vrstvy
  const source = layer.getSource();
  const rawUrl = source.getUrl();

  // Kontrola, či je to WFS služba
  if (!rawUrl.toUpperCase().includes('WFS')) {
    // Ak to nie je WFS služba, vráti undefined
    return undefined;
  }

  // Prispôsobenie URL pre požiadavku DescribeFeatureType
  const baseUrl = rawUrl.split("?")[0];
  const typeName = rawUrl.split("TYPENAME=")[1].split("&")[0];
  const describeFeatureTypeUrl = `${baseUrl}?SERVICE=WFS&VERSION=2.0.0&REQUEST=DescribeFeatureType&TYPENAME=${typeName}`;

  try {
    // Odošle požiadavku DescribeFeatureType
    const response = await fetch(describeFeatureTypeUrl);

    // Skontrolovanie, či je odpoveď v poriadku
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Konverzia odpovede na text
    const data = await response.text();

    // Prevod textu na XML dokument
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(data, "text/xml");

    // Získanie atribútov a ich typov
    const attributeList = [];
    const elements = xmlDoc.getElementsByTagName("xsd:element");

    // Prechádza všetkými elementmi a extrahuje ich názvy a typy
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      const name = element.getAttribute("name");
      let type = element.getAttribute("type");

      // Pre komplexné typy môže byť typ uložený v xsd:simpleType
      if (!type) {
        const simpleType = element.getElementsByTagName("xsd:simpleType")[0];
        if (simpleType) {
          const restriction =
            simpleType.getElementsByTagName("xsd:restriction")[0];
          if (restriction) {
            type = restriction.getAttribute("base");
          }
        }
      }

      // Odstránenie 'xsd:' z typu
      if (type) {
        type = type.replace("xsd:", "");
      }

      // Pridanie atribútu do zoznamu
      attributeList.push({
        name: name,
        type: type,
      });
    }

    // Vrátenie zoznamu atribútov vrstvy
    return attributeList;
  } catch (e) {
    // Výpis chyby ak sa počas operácie niečo pokazí
    console.error("There was a problem with the fetch operation: " + e.message);
  }
}

export async function getLayerExtentAndZoom(layer) {
  // Kontrolujeme, či je vstupný parameter platná vrstva WMS
  if (layer instanceof ImageLayer && layer.getSource() instanceof ImageWMS) {
    // Získanie URL zdroja vrstvy WMS
    const source = layer.getSource();
    const url = source.getUrl();

    // Vytvorenie URL pre GetCapabilities požiadavku
    const capabilitiesUrl = `${url}?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities`;

    // Získanie dat z GetCapabilities požiadavky
    const response = await fetch(capabilitiesUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.text();

    // Analýza vrátených XML dát
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(data, "text/xml");

    // Získanie prvku Layer
    const layerElement = xmlDoc.getElementsByTagName("Layer")[0];
    if (!layerElement) {
      throw new Error(
        "No Layer element found in the WMS GetCapabilities response."
      );
    }

    // Získanie prvku EX_GeographicBoundingBox, ktorý obsahuje informácie o rozsahu vrstvy
    const bboxElement = layerElement.getElementsByTagName(
      "EX_GeographicBoundingBox"
    )[0];
    if (!bboxElement) {
      throw new Error(
        "No EX_GeographicBoundingBox element found in the WMS GetCapabilities response."
      );
    }

    // Získanie hodnôt westBoundLongitude, eastBoundLongitude, southBoundLatitude a northBoundLatitude
    const west = parseFloat(
      bboxElement.getElementsByTagName("westBoundLongitude")[0].textContent
    );
    const east = parseFloat(
      bboxElement.getElementsByTagName("eastBoundLongitude")[0].textContent
    );
    const south = parseFloat(
      bboxElement.getElementsByTagName("southBoundLatitude")[0].textContent
    );
    const north = parseFloat(
      bboxElement.getElementsByTagName("northBoundLatitude")[0].textContent
    );

    // Vytvorenie OpenLayers Extent objektu
    const extent = [west, south, east, north];

    // Nastavenie rozsahu (extent) mapy na rozsah vrstvy a upravenie zoomu mapy
    window.map.getView().fit(extent, window.map.getSize());
  } else {
    console.error(
      "Invalid layer. The function only accepts ImageLayer with ImageWMS source."
    );
  }
}

export function fetchOutputFormats(wfsServiceUrl) {
  return fetch(
    wfsServiceUrl + "?SERVICE=WFS&VERSION=2.0.0&REQUEST=GetCapabilities"
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then((data) => {
      let parser = new DOMParser();
      let xmlDoc = parser.parseFromString(data, "text/xml");

      let parameters = xmlDoc.getElementsByTagName("ows:Parameter");
      let outputFormatParameter;
      for (let i = 0; i < parameters.length; i++) {
        if (parameters[i].getAttribute("name") === "outputFormat") {
          outputFormatParameter = parameters[i];
          break;
        }
      }

      let outputFormats = [];
      if (outputFormatParameter) {
        let outputFormatElements =
          outputFormatParameter.getElementsByTagName("ows:Value");
        for (let i = 0; i < outputFormatElements.length; i++) {
          outputFormats.push(outputFormatElements[i].textContent);
        }
      }

      return outputFormats;
    })
    .catch((e) => {
      console.error(
        "There was a problem with the fetch operation: " + e.message
      );
    });
}

export function parseEsriWms(wmsInfo, callback) {
  let featureType = {};
  featureType["nativeCRS"] = {};
  featureType.nativeCRS["@class"] = "Projected";

  // Zmena interpretácie CRS v závislosti na konkrétnom formáte WMS metadát
  // ...

  featureType["title"] = wmsInfo.name;
  featureType["name"] = wmsInfo.name;
  featureType["nativeBoundingBox"] = {};
  featureType.nativeBoundingBox["minx"] = wmsInfo.extent.xmin;
  featureType.nativeBoundingBox["maxx"] = wmsInfo.extent.xmax;
  featureType.nativeBoundingBox["miny"] = wmsInfo.extent.ymin;
  featureType.nativeBoundingBox["maxy"] = wmsInfo.extent.ymax;
  let nativeBoundingBoxCrs = {};
  nativeBoundingBoxCrs["@class"] = "projected";
  nativeBoundingBoxCrs[
    "$"
  ] = `EPSG:${wmsInfo.extent.spatialReference.latestWkid}`;
  featureType.nativeBoundingBox["crs"] = nativeBoundingBoxCrs;

  // Extrahovať ďalšie informácie v závislosti na konkrétnom formáte WMS metadát
  // ...

  callback(featureType);
}

//   FeaturePopupWithoutGeometry(props)  V HELPERS.js

// export async function getWFSServiceLayerInfo (layer) {
//     const source = layer.getSource();
//     const url = source.getUrl();

//     // Adjust the url as needed for WFS requests
//     const capabilitiesUrl = url + "?SERVICE=WFS&VERSION=1.0.0&REQUEST=GetCapabilities";

//     // Rest of the code similar to getWMSServiceLayerInfo, but adapted to handle WFS data
//     // For example, you may need to handle different XML structure, different bounding box or CRS data, etc.
// };

// export async function getWMSServiceLayerInfo (layer) {
//     const source = layer.getSource();
//     const url = source.getUrl();

//     const capabilitiesUrl =
//       url + "?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities";
//     console.log("capabilitiesUrl", capabilitiesUrl);

//     try {
//       const response = await fetch(capabilitiesUrl);

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.text();
//       const parser = new DOMParser();
//       const xmlDoc = parser.parseFromString(data, "text/xml");

//       const layerElements = xmlDoc.getElementsByTagName("Layer");
//       console.log("layerElements", layerElements);

//       let boundingBox = null;
//       const boundingBoxElements = xmlDoc.getElementsByTagName("BoundingBox");

//       for (let i = 0; i < boundingBoxElements.length; i++) {
//         const element = boundingBoxElements[i];
//         if (element.getAttribute("CRS") === "EPSG:5514") {
//           boundingBox = {
//             minx: parseFloat(element.getAttribute("minx")),
//             miny: parseFloat(element.getAttribute("miny")),
//             maxx: parseFloat(element.getAttribute("maxx")),
//             maxy: parseFloat(element.getAttribute("maxy")),
//           };
//           break;
//         }
//       }

//       for (let i = 0; i < layerElements.length; i++) {
//         const element = layerElements[i];

//         const name = element.getElementsByTagName("Name")[0]?.textContent;
//         const title = element.getElementsByTagName("Title")[0]?.textContent;
//         const abstract =
//           element.getElementsByTagName("Abstract")[0]?.textContent;

//         // Get CRS information
//         const crs = [];
//         const crsElements = element.getElementsByTagName("CRS");
//         for (let j = 0; j < crsElements.length; j++) {
//           const crsValue = crsElements[j]?.textContent;
//           if (crsValue === "EPSG:5514") {
//             // If we find EPSG:5514, we return immediately, prioritizing this CRS
//             return {
//               name: name,
//               title: title,
//               abstract: abstract,
//               crs: crsValue,
//               boundingBox: boundingBox,
//             };
//           }
//           crs.push(crsValue);
//         }

//         console.log("rovna sa?", title === layer.get("displayName"));

//         if (title === layer.get("displayName")) {
//           console.log("DNU SOM");
//           return {
//             name: name,
//             title: title,
//             abstract: abstract,
//             crs: crs.join(", "), // join all CRS values with a comma
//             boundingBox: boundingBox,
//           };
//         }
//       }

//       throw new Error(`No Layer found for layer name: ${layer.get("name")}`);
//     } catch (e) {
//       console.error(
//         "There was a problem with the fetch operation: " + e.message
//       );
//     }
//   };

// Táto funkcia získa informácie o vrstve služby (WMS alebo WFS) a vráti objekt s týmito informáciami.
// Title, bounding box, crs, abstract
export async function getServiceMetadata(layer, serviceType) {
  console.log("------> in getServiceMetadata");

  if (!serviceType) {
    serviceType = detectServiceType(layer);
  }

  const source = layer.getSource();
  const url = source.getUrl();

  //Extract the typeName from URL
  let urlParams = new URLSearchParams(new URL(url).search);
  let typeName = urlParams.get('TYPENAME');

  let capabilitiesUrl;
  if (serviceType === "WMS") {
    capabilitiesUrl =
      url + "?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities";
  } else if (serviceType === "WFS") {
    capabilitiesUrl =
      url + "?SERVICE=WFS&VERSION=1.0.0&REQUEST=GetCapabilities";
  } else {
    throw new Error(`Unsupported service type: ${serviceType}`);
  }

  const response = await fetch(capabilitiesUrl);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.text();
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(data, "text/xml");

  let layerElements;
  if (serviceType === "WMS") {
    layerElements = xmlDoc.getElementsByTagName("Layer");
  } else if (serviceType === "WFS") {
    layerElements = xmlDoc.getElementsByTagName("wfs:FeatureType");
  }

  let boundingBox = null;
  let boundingBoxElements;
  if (serviceType === "WMS") {
    boundingBoxElements = xmlDoc.getElementsByTagName("BoundingBox");
    for (let i = 0; i < boundingBoxElements.length; i++) {
      const element = boundingBoxElements[i];
      if (element.getAttribute("CRS") === "EPSG:5514") {
        boundingBox = {
          minx: parseFloat(element.getAttribute("minx")),
          miny: parseFloat(element.getAttribute("miny")),
          maxx: parseFloat(element.getAttribute("maxx")),
          maxy: parseFloat(element.getAttribute("maxy")),
        };
        break;
      }
    }
  } else if (serviceType === "WFS") {
    boundingBoxElements = xmlDoc.getElementsByTagName("wfs:LatLongBoundingBox");
    for (let i = 0; i < boundingBoxElements.length; i++) {
      const element = boundingBoxElements[i];
      boundingBox = {
        minx: parseFloat(element.getAttribute("minx")),
        miny: parseFloat(element.getAttribute("miny")),
        maxx: parseFloat(element.getAttribute("maxx")),
        maxy: parseFloat(element.getAttribute("maxy")),
      };
      break;
    }
  }

  let abstract;
  for (let i = 0; i < layerElements.length; i++) {
    const element = layerElements[i];

    const crs = [];
    let crsElements;
    let name;
    let title;

    if (serviceType === "WMS") {
      crsElements = element.getElementsByTagName("CRS");
      name = element.getElementsByTagName("Name")[0]?.textContent;
      title = element.getElementsByTagName("Title")[0]?.textContent;
      abstract = element.getElementsByTagName("Abstract")[0]?.textContent;
    } else if (serviceType === "WFS") {
      name = element.getElementsByTagName("wfs:Name")[0]?.textContent;
      if (name === typeName) { // Only process this layer element if it matches the typeName from the URL
        crsElements = element.getElementsByTagName("wfs:SRS");
        title = element.getElementsByTagName("wfs:Title")[0]?.textContent;
        abstract = element.getElementsByTagName("wfs:Abstract")[0]?.textContent;
      }

      // If we didn't find abstract in the layer with matching typeName, then search in all layers
      if (!abstract) {
        for (let j = 0; j < layerElements.length; j++) {
          abstract = layerElements[j].getElementsByTagName("wfs:Abstract")[0]?.textContent;
          if (abstract) {
            break;
          }
        }
      }
    }
    if (crsElements) {
      for (let j = 0; j < crsElements.length; j++) {
        const crsValue = crsElements[j]?.textContent;
        if (crsValue === "EPSG:5514") {
          return {
            name: name,
            title: title,
            abstract: abstract,
            crs: crsValue,
            boundingBox: boundingBox,
          };
        }
        crs.push(crsValue);
      }
    }

    if (title === layer.get("displayName")) {
      return {
        name: name,
        title: title,
        abstract: abstract,
        crs: crs.join(", "),
        boundingBox: boundingBox,
      };
    }
  }

  throw new Error(`No Layer found for layer name: ${layer.get("name")}`);
}

// export async function getLayerCRS(layer) {
//   console.log("in getLayerCRS");
//   // Získanie URL zdroja vrstvy
//   const source = layer.getSource();
//   const rawUrl = source.getUrl();
//   console.log("rawUrl", rawUrl);

//   // Zistenie, či je to WFS alebo WMS služba
//   let isWFS = false;
//   let layerName = "";
//   if (rawUrl.toUpperCase().includes("WFS")) {
//     isWFS = true;
//     if (rawUrl.includes("TYPENAME=")) {
//       layerName = rawUrl.split("TYPENAME=")[1].split("&")[0];
//     }
//   } else if (rawUrl.toUpperCase().includes("WMS")) {
//     if (rawUrl.includes("LAYERS=")) {
//       layerName = rawUrl.split("LAYERS=")[1].split("&")[0];
//     } else {
//       // Default layer name when no layer parameter is found
//       layerName = "default";
//     }
//   } else {
//     console.error(
//       "The service type (WFS/WMS) could not be determined from the URL."
//     );
//     return null;
//   }

//   // Prispôsobenie URL pre požiadavku GetCapabilities
//   const baseUrl = rawUrl.split("?")[0];
//   const getCapabilitiesUrl = `${baseUrl}?SERVICE=${isWFS ? "WFS" : "WMS"
//     }&VERSION=2.0.0&REQUEST=GetCapabilities${layerName !== 'default' ? `&LAYERS=${layerName}` : ''}`;
//   console.log("getCapabilitiesUrl", getCapabilitiesUrl);


//   try {
//     // Odošle požiadavku GetCapabilities
//     const response = await fetch(getCapabilitiesUrl);

//     // Skontrolovanie, či je odpoveď v poriadku
//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }
//     // Konverzia odpovede na text
//     const data = await response.text();
//     // Prevod textu na XML dokument
//     const parser = new DOMParser();
//     const xmlDoc = parser.parseFromString(data, "text/xml");

//     // Získanie súradnicového systému pre danú vrstvu
//     let crsList = [];
//     let preferredCrs = null;
//     const layers = xmlDoc.getElementsByTagName(
//       isWFS ? "wfs:FeatureType" : "Layer"
//     );
//     for (let i = 0; i < layers.length; i++) {
//       const layerElement = layers[i];
//       const nameElement = layerElement.getElementsByTagName(
//         isWFS ? "wfs:Name" : "Name"
//       )[0];
//       if (nameElement.textContent === layerName) {
//         const crsElements = layerElement.getElementsByTagName(
//           isWFS ? "wfs:DefaultCRS" : "CRS"
//         );
//         for (let j = 0; j < crsElements.length; j++) {
//           let fullCrs = crsElements[j].textContent;
//           if (!isWFS) {
//             fullCrs = "EPSG::" + fullCrs;
//           }
//           const epsgCode = fullCrs.split("::").pop();
//           const crs = `EPSG:${epsgCode}`;
//           crsList.push(crs);
//           if (epsgCode === "5514") {
//             preferredCrs = crs;
//           }
//         }
//         break;
//       }
//     }

//     if (preferredCrs) {
//       console.log("Preferred CRS found:", preferredCrs);
//       return preferredCrs;
//     } else {
//       console.log("All available CRS:", crsList);
//       return crsList;
//     }
//   } catch (e) {
//     // Výpis chyby ak sa počas operácie niečo pokazí
//     console.error("There was a problem with the fetch operation: " + e.message);
//   }
// }

// Pomocná funkcia na získanie a parsovanie XML dokumentu
async function fetchAndParseXML(url) {
  const response = await fetch(url);

  // Skontrolovanie, či je odpoveď v poriadku
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // Konverzia odpovede na text
  const data = await response.text();
  // Prevod textu na XML dokument
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(data, "text/xml");

  return xmlDoc;
}

// Funkcia na získanie 'abstract' a 'title'
export async function getLayerDescription(layer) {
  console.log("in getLayerDescription");
  const source = layer.getSource();
  const rawUrl = source.getUrl();

  // Zistenie, či je to WFS alebo WMS služba
  let serviceType = "";
  if (rawUrl.toUpperCase().includes("WFS")) {
    serviceType = "WFS";
  } else if (rawUrl.toUpperCase().includes("WMS")) {
    serviceType = "WMS";
  } else {
    console.error(
      "The service type (WFS/WMS) could not be determined from the URL."
    );
    return null;
  }

  // Prispôsobenie URL pre požiadavku GetCapabilities
  const baseUrl = rawUrl.split("?")[0];
  const getCapabilitiesUrl = `${baseUrl}?SERVICE=${serviceType}&VERSION=2.0.0&REQUEST=GetCapabilities`;

  try {
    // Odošle požiadavku GetCapabilities a parsuje odpoveď
    const xmlDoc = await fetchAndParseXML(getCapabilitiesUrl);
    // Získanie 'title' a 'abstract' pre danú vrstvu
    // const serviceIdentification = xmlDoc.getElementsByTagName(
    //   "ows:ServiceIdentification"
    // )[0];
    const titleElement =
      xmlDoc.getElementsByTagName("Title")[0];
    const abstractElement =
      xmlDoc.getElementsByTagName("Abstract")[0];

    const title = titleElement ? titleElement.textContent : null;
    const abstract = abstractElement ? abstractElement.textContent : null;

    return {
      title: title,
      abstract: abstract,
    };
  } catch (e) {
    // Výpis chyby ak sa počas operácie niečo pokazí
    console.error("There was a problem with the fetch operation: " + e.message);
  }
}

// Funkcia na získanie bounding boxu
export async function getLayerBoundingBox(layer) {
  const source = layer.getSource();
  const rawUrl = source.getUrl();

  // Zistenie, či je to WFS alebo WMS služba
  let isWFS = false;
  let layerName = "";
  if (rawUrl.toUpperCase().includes("WFS")) {
    isWFS = true;
    layerName = rawUrl.split("TYPENAME=")[1].split("&")[0];
  } else if (rawUrl.toUpperCase().includes("WMS")) {
    layerName = rawUrl.split("LAYERS=")[1].split("&")[0];
  } else {
    console.error(
      "The service type (WFS/WMS) could not be determined from the URL."
    );
    return null;
  }

  // Prispôsobenie URL pre požiadavku GetCapabilities
  const baseUrl = rawUrl.split("?")[0];
  const getCapabilitiesUrl = `${baseUrl}?SERVICE=${isWFS ? "WFS" : "WMS"
    }&VERSION=2.0.0&REQUEST=GetCapabilities`;

  try {
    // Odošle požiadavku GetCapabilities a parsuje odpoveď
    const xmlDoc = await fetchAndParseXML(getCapabilitiesUrl);

    // Získanie bounding boxu pre danú vrstvu
    const layers = xmlDoc.getElementsByTagName(
      isWFS ? "wfs:FeatureType" : "Layer"
    );
    for (let i = 0; i < layers.length; i++) {
      const layerElement = layers[i];
      const nameElement = layerElement.getElementsByTagName(
        isWFS ? "wfs:Name" : "Name"
      )[0];
      if (nameElement.textContent === layerName) {
        const bboxElement = layerElement.getElementsByTagName(
          isWFS ? "ows:WGS84BoundingBox" : "EX_GeographicBoundingBox"
        )[0];
        let bbox = null;
        if (bboxElement) {
          const lowerCorner = bboxElement
            .getElementsByTagName(
              isWFS ? "ows:LowerCorner" : "westBoundLongitude"
            )[0]
            .textContent.split(" ")
            .map(parseFloat);
          const upperCorner = bboxElement
            .getElementsByTagName(
              isWFS ? "ows:UpperCorner" : "eastBoundLongitude"
            )[0]
            .textContent.split(" ")
            .map(parseFloat);

          bbox = {
            lowerCorner: lowerCorner,
            upperCorner: upperCorner,
          };
        }

        return bbox;
      }
    }
  } catch (e) {
    // Výpis chyby ak sa počas operácie niečo pokazí
    console.error("There was a problem with the fetch operation: " + e.message);
  }
}

export function detectServiceType(layer) {
  const url = layer.getSource().getUrl();
  if (url.toLowerCase().includes("wms")) {
    return "WMS";
  } else if (url.toLowerCase().includes("wfs")) {
    return "WFS";
  } else {
    return null;
  }
}


export function flattenObj(data, parentKey = '', excludedKeys = []) {

  let flatData = {};
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      if (excludedKeys.includes(key)) {
        flatData[key] = data[key];
        continue;
      }

      let newKey = parentKey ? `${parentKey}_${key}` : key;

      if (typeof data[key] === 'object' && data[key] !== null && !Array.isArray(data[key])) {
        Object.assign(flatData, flattenObj(data[key], newKey, excludedKeys));
      } else {
        flatData[newKey] = data[key];
      }
    }
  }
  return flatData;
}

export function getProcessedFeatures(result, api_url, uniqueTabname, layerSource) {
  // const uniqueTabname = getUniqueName(
  //   `KN_${result.parcelno}`,
  //   "",
  //   extractUsedFilterNames(window.config.storageKeyFilterResults)
  // );
  // console.log("uniqueTabname", uniqueTabname);

  const processSingleObject = (singleResult) => {

    const rawGeoJson = singleResult.rawGeometry || singleResult.geometry || singleResult.geom || singleResult.values_.geometry;
    const feature = helpers.getFeatureFromGeoJSON(rawGeoJson);
    singleResult.rawGeometry = rawGeoJson;  // Uchovávame pôvodnú GeoJSON dátu
    singleResult.geometry = feature.getGeometry();

    let excluded = ["geometry", "geom", "rawGeometry"];
    feature.values_ = flattenObj(singleResult, '', excluded);

    const parcelno = feature.values_.No || feature.values_.parcelno;

    const uniqueFilterName = getUniqueName(
      parcelno ? `${uniqueTabname}_${parcelno}` : "Záznam",
      "",
      extractUsedFilterNames(window.config.storageKeyFilterResults)
    );

    // feature.id_ = uniqueFilterName;
    feature.id_ = `${layerSource}_${feature.ol_uid}`;

    feature.tabName = uniqueFilterName;
    feature.api_url = api_url;
    feature.layerName = layerSource;


    return feature;
  };

  let features = [];

  if (Array.isArray(result)) {
    features = result.map(singleResult => processSingleObject(singleResult));
  } else {
    features = [processSingleObject(result)];
  }
  return features;
}

// export function getProcessedFeatures(result, api_url) {
//   const processSingleObject = (singleResult) => {
//     console.log("singleResult", singleResult);

//     const rawGeoJson = singleResult.rawGeometry || singleResult.geometry || singleResult.geom  || singleResult.values_.geometry;
//     const feature = helpers.getFeatureFromGeoJSON(rawGeoJson);
//     singleResult.rawGeometry = rawGeoJson;  // Uchovávame pôvodnú GeoJSON dátu
//     singleResult.geometry = feature.getGeometry();

//     let excluded = ["geometry", "geom"];
//     feature.values_ = flattenObj(singleResult, '', excluded);

//     console.log("vyberam meno", feature);

//     const parcelno = feature.values_.No || feature.values_.parcelno;
//     console.log("parcelno", parcelno);

//     const uniqueFilterName = getUniqueName(
//       `kn_${parcelno}`,
//       "",
//       extractUsedFilterNames(window.config.storageKeyFilterResults)
//     );
//     console.log("--> uniqueFilterName", uniqueFilterName);

//     feature.id_ = uniqueFilterName;
//     feature.tabName = uniqueFilterName;
//     feature.api_url = api_url;
//     feature.layerName = uniqueFilterName;

//     return feature;
//   };

//   let features = [];

//   if (Array.isArray(result)) {
//     console.log("result je pole", result);
//     features = result.map(singleResult => processSingleObject(singleResult));
//   } else {
//     console.log("result nie je pole");
//     features = [processSingleObject(result)];
//   }

//   return features;
// }


// export function processResult(result, api_url, tabname, layerSource) {
//   console.log("result from processResult ", result);

//   const processSingleObject = (singleResult) => {

//     console.log("singleResult", singleResult);

//     const rawGeoJson = singleResult.rawGeometry || singleResult.geometry || singleResult.geom  || singleResult.values_.geometry;
//     const feature = helpers.getFeatureFromGeoJSON(rawGeoJson);
//     singleResult.rawGeometry = rawGeoJson;  // Uchovávame pôvodnú GeoJSON dátu
//     singleResult.geometry = feature.getGeometry();

//     let excluded = ["geometry", "geom"];
//     feature.values_ = flattenObj(singleResult, '', excluded);

//     console.log("vyberam meno", feature);

//     const parcelno = feature.values_.No || feature.values_.parcelno;
//     console.log("parcelno", parcelno);

//     const uniqueFilterName = getUniqueName(
//       `kn_${parcelno}`,
//       "",
//       extractUsedFilterNames(window.config.storageKeyFilterResults)
//     );
//     console.log("--> uniqueFilterName", uniqueFilterName);

//     feature.id_ = uniqueFilterName;
//     feature.tabName = uniqueFilterName;
//     feature.api_url = api_url;
//     feature.layerName = uniqueFilterName;

//     return feature;
//   };

//   let features = [];

//   const uniqueTabname = getUniqueName(
//     `KN_${result.parcelno}`,
//     // `kn_${feature.values_.No}`,
//     "",
//     extractUsedFilterNames(window.config.storageKeyFilterResults)
//   );

//   console.log("uniqueTabname", uniqueTabname);


//   if (Array.isArray(result)) {
//     console.log("result je pole", result);
//     features = result.map(singleResult => processSingleObject(singleResult));
//   } else {
//     console.log("result nie je pole");
//     features = [processSingleObject(result)];
//   }

//   window.emitter.emit(
//     "renderFeature",
//     features,
//     // "kn",
//     tabname || uniqueTabname,
//     tabname || uniqueTabname,
//     uniqueTabname,
//     layerSource,
//     true
//   );
//   // helpers.zoomToFeature(features);
//   // window.emitter.emit("highlightOnMap", features);

//   window.emitter.emit(
//     "openAttTabGEOJSON",
//     tabname || uniqueTabname,
//     features,
//     uniqueTabname,
//     layerSource,
//     tabname || uniqueTabname,
//     null,
//     false
//   );

//   return features;
// }


export function processResult_geomLess(results, api_url, tabname, layerSource) {
  console.log("processResult_geomLess");

  const processSingleObject = (result) => {
    const feature = new Feature();

    let excluded = ["geometry", "geom", "rawGeometry"];
    feature.setProperties(flattenObj(result, '', excluded));

    const no = feature.get('No') || feature.get('houseno') || feature.get('lv');
    const uniqueFilterName = getUniqueName(
      `kn_${no}`,
      "",
      extractUsedFilterNames(window.config.storageKeyFilterResults)
    );

    feature.setId(uniqueFilterName);
    feature.set('tabName', uniqueFilterName);
    feature.set('api_url', api_url);

    return feature;
  };

  let features = [];

  const uniqueTabname = getUniqueName(
    `kn_`,
    "",
    extractUsedFilterNames(window.config.storageKeyFilterResults)
  );

  if (Array.isArray(results)) {
    features = results.map(result => processSingleObject(result));
  } else {
    features = [processSingleObject(results)];
  }

  window.emitter.emit(
    "openAttTabGEOJSON",
    tabname || uniqueTabname,
    features,
    tabname || uniqueTabname,
    layerSource,
    "kn"
  );

  return features;
}


export function getFeatureById(id) {
  const drawingLayerName = "local:myMaps";
  let feature = null;
  window.map.getLayers().forEach((layer) => {
    if (layer.getProperties().name === drawingLayerName) {
      layer
        .getSource()
        .getFeatures()
        .forEach((feat) => {
          if (feat.get("id") === id) feature = feat;
          return;
        });
    }
  });

  return feature;
}
export function getFeatureByLayerName(layerName,) {
  console.log("getFeatureByLayerName");
  let feature = null;
  window.map.getLayers().forEach((layer) => {

    if (layer.getProperties().name === layerName) {
      layer
        .getSource()
        .getFeatures()
        .forEach((feat) => {
          feature = feat;
          return;
        });
    }
  });

  return feature;
}

export function isLocalStorageAvailable() {
  try {
    const testKey = "test";
    localStorage.setItem(testKey, "testValue");
    localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
}

export function createFeatureFromGeoJson(geoJsonArray) {
  console.log("createFeatureFromGeoJson");
  const features = [];

  for (let geojson of geoJsonArray) {

    const geometryType = geojson.values_.rawGeometry_type || geojson.values_.rawGeometry.type;
    let newGeometry;
    const coord = geojson.values_.rawGeometry.coordinates || geojson.values_.rawGeometry.geom.coordinates;

    switch (geometryType) {
      case 'Polygon':
        newGeometry = new Polygon(coord);
        break;
      case 'LineString':
        newGeometry = new LineString(coord);
        break;
      case 'Point':
        newGeometry = new Point([coord[0], coord[1]]);
        break;
      default:
        console.error(`Nepodporovaný typ geometrie: ${geometryType}`);
    }

    const properties = {
      ...geojson.values_,
      geometry: newGeometry
    };

    const feature = new Feature(properties);
    feature.id_ = [geojson.layerSource, geojson.tabName, geojson.ol_uid].join("-");
    feature.tabName = geojson.tabName || geojson.name;

    features.push(feature);
  }
  // features.ol_uid <- null
  return features;
}